import React, { createContext, useState } from 'react'

// @ts-ignore
export const StoreContext = createContext()

const StoreContextProvider = ({children}) => {
 
  const [pageLoading, setPageLoading] = useState(false) 
  const [showMobileSidebar, setShowMobileSidebar] = useState(false)

  return <StoreContext.Provider value={{ 
    pageLoading, setPageLoading,
    showMobileSidebar, setShowMobileSidebar,
  }}>
    {children}
  </StoreContext.Provider>
}
export default StoreContextProvider